"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../../shared"));

var _Dropdown = _interopRequireDefault(require("../../Dropdown/Dropdown"));

var _Icon = _interopRequireDefault(require("../../Icon/Icon"));

var _SettingsItem = _interopRequireDefault(require("./SettingsItem"));

var _List = _interopRequireDefault(require("../../List/List"));

var _SettingsLink = _interopRequireDefault(require("./SettingsLink"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
Settings dropdown for header bar
*/
function Settings(_ref) {
  var children = _ref.children,
      open = _ref.open,
      className = _ref.className,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["children", "open", "className"]);

  var cssClasses = ['st_headerbar__item', 'st_headerbar__settings'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: cssClasses.join(' ')
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    padding: {
      all: 'none'
    },
    defaultOpen: open,
    trigger: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      type: "gear",
      color: "ink"
    }),
    position: "right"
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
    margin: {
      horizontal: 'none',
      vertical: 'smd'
    }
  }, children)));
}

Settings.propTypes = {
  /** whether dropdown is open or closed */
  open: _propTypes["default"].bool,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps
};
Settings.defaultProps = {
  open: false,
  className: null
};
Settings.displayName = 'HeaderBar.Settings';
Settings.Item = _SettingsItem["default"];
Settings.Link = _SettingsLink["default"];
var _default = Settings;
exports["default"] = _default;